module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Dj7T"))).then(() => parcelRequire('5erN3'));